"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const getState_1 = require("../../helpers/getState");
const setVersionIdOfState_1 = tslib_1.__importDefault(require("../../helpers/versions/setVersionIdOfState"));
const zeroStates_1 = require("../../zeroStates");
const addAssignEvent_1 = tslib_1.__importDefault(require("./addAssignEvent"));
const updateEnrolments_1 = tslib_1.__importDefault(require("./updateEnrolments"));
function applyAssignCheckpoint(command, user, content, states, enrolments, stateInteractions) {
    let updatedEnrolments = enrolments;
    const newEvents = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        let state = getState_1.getStateByContentIdUserId(draftStates, content._id, user.userId);
        if (!state) {
            const checkpointStates = zeroStates_1.zeroStates(content, user);
            state = checkpointStates[0];
            draftStates.push(...checkpointStates);
        }
        setVersionIdOfState_1.default(command, content, state);
        updatedEnrolments = updateEnrolments_1.default(enrolments, command, content, user);
        const diffEnrolments = updatedEnrolments.filter((enrolment, index) => {
            if (enrolment !== enrolments[index]) {
                return enrolment;
            }
        });
        if (diffEnrolments.length > 0) {
            addAssignEvent_1.default(command, updatedEnrolments, user, content, newEvents);
        }
    });
    return {
        events: newEvents,
        states: updatedStates,
        stateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.applyAssignCheckpoint = applyAssignCheckpoint;
//# sourceMappingURL=applyAssignCheckpoint.js.map